import React from 'react'

const Testimonials = () => {
  return (
    <div  className='h-[70vh] lg:h-[120vh]  w-[100vw] pt-28 lg:pt-24 lg:w-full overflow-x-hidden py-6'>
        {/* <h1 className='text-center text-3xl font-bold pt-20 md:pt-28 lg:pt-16 pb-6'>Testimonials</h1> */}
        <div className=' h-full flex flex-col gap-4 items-center lg:gap-2'>
        <h1 className='text-4xl md:text-5xl  font-mosk700' >Testimonials</h1>
        <iframe className='h-[30vh] md:h-[40vh] lg:h-[90%] shadow-xl w-[90%] 3xl:w-[70%] rounded-lg' src="https://www.youtube.com/embed/Dd6rVSxDqek?si=n0OV4peS-41BnEzW&rel=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
       </div>
    </div>
  )
}

export default Testimonials
